import { Icon12InfoCircle, Icon16Cancel, Icon16Stars } from '@vkontakte/icons';
import { Switch } from '@vkontakte/vkui';
import classNames from 'clsx';
import starsAnimation from 'img/aiTariff/stars.gif';
import React, { memo, useCallback, useState } from 'react';
import { sendDwhRadar } from 'reactApp/modules/dwh/dwh.helpers';
import { renderAiTariffPromoDialog } from 'reactApp/sections/QuotaLanding/aiTariffPromoDialog/aiTariffPromo.helpers';
import { noopUndefined } from 'reactApp/utils/helpers';

import styles from './FeatureSwitch.css';

interface Props {
    switchOn?: boolean;
    disabled?: boolean;

    onChanged?(): void;
}

export const FeatureSwitch = memo<Props>(({ switchOn = false, onChanged = noopUndefined, disabled = false }) => {
    const [showAnimationUrl, setShowAnimationUrl] = useState<string>('');
    const showHelp = useCallback(() => {
        sendDwhRadar({ t: 'union-quota', action: 'icon-info', name: 'mnz_neiro_functions' });
        renderAiTariffPromoDialog({});
    }, []);

    const handleOnChange = useCallback(() => {
        onChanged();
        setShowAnimationUrl(!switchOn ? `${starsAnimation}?${Math.random()}` : '');
    }, [switchOn, onChanged]);

    if (disabled) {
        return (
            <div className={styles.rootDisabled}>
                <Icon16Cancel />
                <div className={styles.text}>Функции нейросети</div>
            </div>
        );
    }

    return (
        <div className={classNames(styles.root, { [styles.root_off]: !switchOn })}>
            <img src={showAnimationUrl} className={styles.starsAnimation} />
            <Icon16Stars />
            <div className={styles.text}>
                Функции нейросети
                <div className={styles.info} onClick={showHelp}>
                    <Icon12InfoCircle width={12} height={12} />
                </div>
            </div>
            <Switch name="ai-tariff-by-options" checked={switchOn} onChange={handleOnChange} />
        </div>
    );
});

FeatureSwitch.displayName = 'FeatureSwitch';
